(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-good"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      //this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      //this.disclosures.forEach(disclosure => disclosure.close());
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        disclosure.removeAttribute('open');
        disclosure.querySelector('.mega-menu__content').setAttribute('aria-expanded', false);
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zeta-hero-countdown')) {
  customElements.define('zeta-hero-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      // The deferred section asset also covers subsequent theme-editor insertions.
      this.frame = requestAnimationFrame(() => this.start());
    }
    disconnectedCallback() { this.stop(); }
    stop() {
      cancelAnimationFrame(this.frame);
      clearInterval(this.timer);
      this.timer = null;
    }
    start() {
      this.clock = this.querySelector('.zh-clock');
      this.message = this.querySelector('.zh-expired');
      if (!this.clock || !this.message) return;
      const date = (this.dataset.date || '').trim();
      const time = (this.dataset.time || '').trim();
      const zone = (this.dataset.zone || '+00:00').trim();
      const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
      const timeValid = /^(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d)?$/.test(time);
      const zoneValid = /^(?:Z|[+-](?:(?:0\d|1[0-3]):[0-5]\d|14:00))$/.test(zone);
      const calendar = new Date(date + 'T00:00:00Z');
      const dateValid = dateMatch && Number.isFinite(calendar.getTime()) && calendar.toISOString().slice(0, 10) === date;
      this.target = dateValid && timeValid && zoneValid ? Date.parse(date + 'T' + time + zone) : NaN;
      if (!Number.isFinite(this.target)) {
        this.hidden = this.dataset.editor !== 'true';
        this.clock.hidden = true;
        this.message.hidden = false;
        this.message.textContent = 'Compte à rebours : vérifiez la date, l’heure et le décalage UTC.';
        return;
      }
      this.nodes = Object.fromEntries(['days', 'hours', 'minutes', 'seconds'].map(key => [key, this.querySelector('[data-unit="' + key + '"]')]));
      this.hidden = false;
      this.message.hidden = true;
      this.clock.hidden = false;
      if (this.update()) this.timer = setInterval(() => this.update(), 1000);
    }
    update() {
      const remaining = this.target - Date.now();
      if (remaining <= 0) {
        this.stop();
        this.clock.hidden = true;
        this.message.textContent = this.dataset.expired || '';
        this.message.hidden = !this.message.textContent;
        this.hidden = !this.message.textContent;
        return false;
      }
      const total = Math.ceil(remaining / 1000);
      const values = { days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
      for (const [key, value] of Object.entries(values)) this.nodes[key].textContent = String(value).padStart(2, '0');
      const hideDays = this.dataset.hideDays === 'true' && values.days === 0;
      this.querySelector('[data-days]').hidden = hideDays;
      this.querySelector('[data-days-separator]').hidden = hideDays;
      return true;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  if (customElements.get('zeta-collection-countdown')) return;
  const paris = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  function parisDeadline(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value.trim());
    if (!match) return NaN;
    const [year, month, day, hour, minute, second] = match.slice(1).map(v => Number(v || 0));
    const wall = Date.UTC(year, month - 1, day, hour, minute, second);
    const wanted = { year, month, day, hour, minute, second };
    // Check both Paris offsets. A missing spring hour is invalid; for the
    // repeated autumn hour, the later (winter-time) occurrence is used.
    const candidates = [120, 60].map(offset => wall - offset * 60000).filter(stamp => {
      const parts = Object.fromEntries(paris.formatToParts(stamp).map(p => [p.type, p.value]));
      return Object.entries(wanted).every(([key, number]) => Number(parts[key]) === number);
    });
    return candidates.length ? Math.max(...candidates) : NaN;
  }
  customElements.define('zeta-collection-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.hidden = true;
      this.deadline = parisDeadline(this.dataset.end || '');
      if (!Number.isFinite(this.deadline)) {
        if (window.Shopify?.designMode) {
          const message = this.querySelector('[data-countdown-error]');
          if (message) {
            this.querySelector('[data-countdown-display]').hidden = true;
            message.hidden = false; this.hidden = false;
          }
        }
        return;
      }
      this.fields = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-' + unit + ']'));
      if (this.fields.some(field => !field)) return;
      this.tick = () => {
        const remaining = Math.ceil((this.deadline - Date.now()) / 1000);
        if (remaining <= 0) { this.hidden = true; this.stop(); return; }
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        values.forEach((value, index) => { this.fields[index].textContent = String(value).padStart(2, '0'); });
        this.hidden = false;
      };
      this.tick();
      if (!this.hidden) {
        this.interval = setInterval(this.tick, 1000);
        this.visibility = () => { if (!document.hidden) this.tick(); };
        document.addEventListener('visibilitychange', this.visibility);
      }
    }
    stop() {
      clearInterval(this.interval);
      if (this.visibility) document.removeEventListener('visibilitychange', this.visibility);
    }
    disconnectedCallback() { this.stop(); }
  });
})();
(() => {
  if (customElements.get('zeta-type-navigation')) return;
  const parameter = 'filter.p.product_type';
  customElements.define('zeta-type-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.facets = this.closest('zeta-minimal-facets') || this.parentElement;
      this.refresh = () => this.sync();
      this.click = event => {
        const link = event.target.closest('a[data-type-values]');
        if (!link || !this.contains(link)) return;
        this.sync();
        // Native links preserve keyboard activation, modifier keys and new tabs.
      };
      this.addEventListener('click', this.click);
      this.addEventListener('pointerdown', this.refresh);
      this.addEventListener('focusin', this.refresh);
      this.facets.addEventListener('change', this.refresh);
      window.addEventListener('popstate', this.refresh);
      window.addEventListener('pageshow', this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.facets, { childList: true, subtree: true });
      this.sync();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.click);
      this.removeEventListener('pointerdown', this.refresh);
      this.removeEventListener('focusin', this.refresh);
      this.facets.removeEventListener('change', this.refresh);
      window.removeEventListener('popstate', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
      this.observer.disconnect();
      this.observer = null;
    }
    sync() {
      const current = new URL(window.location.href);
      const inputs = [...this.facets.querySelectorAll('input[type="checkbox"][name="filter.p.product_type"]')];
      const selected = new Set(inputs.length
        ? inputs.filter(input => input.checked).map(input => input.value)
        : current.searchParams.getAll(parameter).flatMap(value => value.split(',')));
      this.querySelectorAll('a[data-type-values]').forEach(link => {
        const values = JSON.parse(link.dataset.typeValues);
        const active = values.length ? values.some(value => selected.has(value)) : selected.size === 0;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        const target = new URL(current);
        target.searchParams.delete(parameter);
        target.searchParams.delete('page');
        target.searchParams.delete('section_id');
        target.searchParams.delete('sections');
        if (!active) values.forEach(value => target.searchParams.append(parameter, value));
        link.href = target.href;
      });
    }
  });
})();


/* Le composant se reconnecte après rechargement de section ou filtrage AJAX. */
(() => {
  if (customElements.get('zeta-collection-signup')) return;
  customElements.define('zeta-collection-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.openSignup) return;
      this.openSignup = event => {
        const button = event.target.closest('[data-zeta-signup-popup]');
        if (!button || !this.contains(button)) return;
        const formId = button.dataset.zetaSignupPopup;
        if (!/^[a-zA-Z0-9]+$/.test(formId || '')) return;
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      };
      this.addEventListener('click', this.openSignup);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.openSignup);
      this.openSignup = null;
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zeta-model-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zeta-model-grid')) {
  customElements.define('zeta-model-grid', class extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return;
      this._mounted = true;
      const root = this;
      const cleanups = this._cleanups = [];
      const tabs = Array.from(root.querySelectorAll('[data-zmg-tab]'));
      const tabStrip = root.querySelector('.zmg-tabs');
      const tabShell = root.querySelector('[data-zmg-tabs-shell]');
      const panels = Array.from(root.querySelectorAll('[data-zmg-panel]'));
      const breakpoint = window.matchMedia('(min-width: 990px)');
      const selectedModels = new Map();
      const requests = new Map();
      const aborter = new AbortController();
      cleanups.push(() => aborter.abort());
      let active = tabs[0]?.dataset.zmgTab;
      let serial = 0;
      function listen(target, type, callback) {
        target.addEventListener(type, callback);
        cleanups.push(() => target.removeEventListener(type, callback));
      }
      function syncTabScrollCue() {
        if (!tabStrip || !tabShell) return;
        const canScrollRight = tabStrip.scrollWidth - tabStrip.clientWidth - tabStrip.scrollLeft > 3;
        tabShell.classList.toggle('is-scrollable-right', canScrollRight);
      }
      if (tabStrip) listen(tabStrip, 'scroll', syncTabScrollCue);
      listen(window, 'resize', syncTabScrollCue);
      if (typeof ResizeObserver !== 'undefined' && tabStrip && tabShell) {
        const tabObserver = new ResizeObserver(syncTabScrollCue);
        tabObserver.observe(tabShell);
        tabs.forEach(tab => tabObserver.observe(tab));
        cleanups.push(() => tabObserver.disconnect());
      }
      function limit() { return Number(breakpoint.matches ? root.dataset.desktop : root.dataset.mobile) || 4; }
      function activePanel() { return panels.find(p => p.dataset.zmgPanel === active); }
      function currentView(panel) {
        const model = selectedModels.get(panel.dataset.zmgPanel) || 'all';
        return Array.from(panel.querySelectorAll('[data-zmg-view]')).find(v => v.dataset.zmgView === model);
      }
      function refresh() {
        panels.forEach(panel => {
          panel.hidden = panel.dataset.zmgPanel !== active;
          const view = currentView(panel);
          panel.querySelectorAll('[data-zmg-view]').forEach(v => { v.hidden = v !== view; });
          panel.querySelectorAll('[data-zmg-model]').forEach(a => a.setAttribute('aria-current', String(a.dataset.zmgModel === view.dataset.zmgView)));
          const wanted = limit() * (1 + Number(view.dataset.batches || 0));
          const items = Array.from(view.querySelectorAll('[data-zmg-item]'));
          items.forEach((item, i) => { item.hidden = i >= wanted; });
          const visibleCount = Math.min(items.length, wanted);
          const grid = view.querySelector('.zmg-grid');
          // Keep short selections in one desktop row, without enlarging a single card.
          grid.dataset.compact = String(!view.dataset.next && visibleCount > 0 && visibleCount <= 5);
          grid.style.setProperty('--zmg-short-columns', Math.max(1, visibleCount));
          grid.style.setProperty('--zmg-short-width', visibleCount < 4 ? (visibleCount * 25) + '%' : '100%');
          const busy = requests.has(view);
          const error = view.dataset.failed === 'true';
          const more = panel.querySelector('[data-zmg-more]');
          more.hidden = error || (items.length <= wanted && !view.dataset.next);
          more.disabled = busy;
          panel.querySelector('[data-zmg-retry]').hidden = !error;
          const message = panel.querySelector('[data-zmg-message]');
          message.hidden = !busy && !error;
          message.textContent = error ? root.dataset.error : root.dataset.loading;
          view.setAttribute('aria-busy', String(busy));
          if (!panel.hidden) {
            const counter = root.querySelector('[data-zmg-count]');
            if (counter) {
              const total = view.dataset.total;
              counter.hidden = total === undefined || total === '';
              if (!counter.hidden) {
                counter.textContent = '(' + total + ')';
                counter.setAttribute('aria-label', counter.dataset.label.replace('[count]', total));
              }
            }
            const cta = root.querySelector('[data-zmg-current-link]');
            cta.hidden = !view.dataset.url;
            if (view.dataset.url) cta.href = view.dataset.url;
            view.querySelectorAll('[data-zeta-gallery]').forEach(gallery => {
              if (gallery.getClientRects().length) initGallery(gallery);
            });
          }
        });
        tabs.forEach(tab => {
          const selected = tab.dataset.zmgTab === active;
          tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1;
        });
        syncTabScrollCue();
      }
      async function loadPage(view) {
        if (requests.has(view)) return requests.get(view);
        const target = view.dataset.loaded === 'true' ? view.dataset.next : view.dataset.url;
        if (!target) return;
        const promise = (async () => {
          // Yield once so the pending request is recorded before updating the UI.
          await Promise.resolve(); refresh();
          try {
            const url = new URL(target, location.origin);
            if (url.origin !== location.origin) throw new Error('Invalid origin');
            url.searchParams.set('section_id', 'zeta-model-grid');
            const response = await fetch(url, {signal:aborter.signal});
            if (!response.ok) throw new Error('HTTP '+response.status);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const data = doc.querySelector('[data-zmg-response]');
            if (!data) throw new Error('Missing section');
            const grid = view.querySelector('.zmg-grid');
            const known = new Set(Array.from(grid.children).map(li => li.dataset.productId));
            data.querySelectorAll('template[data-zmg-product]').forEach(template => {
              if (known.has(template.dataset.zmgProduct)) return;
              const variant = (root.dataset.lifestyle === 'true' && template.content.querySelector('[data-zmg-lifestyle]')) || template.content.querySelector('[data-zmg-standard]');
              if (!variant) return;
              const li = document.createElement('li');
              li.className = 'grid__item'; li.dataset.zmgItem = ''; li.dataset.productId = template.dataset.zmgProduct;
              li.hidden = true; li.appendChild(variant.content.cloneNode(true));
              if (root.dataset.quickAdd === 'false') li.querySelectorAll('[data-zqa-open]').forEach(a => a.remove());
              // Response section IDs repeat across instances: namespace IDs and references.
              const replacements = new Map();
              li.querySelectorAll('[id]').forEach(el => {
                const old = el.id; el.id = root.closest('[id]').id + '-loaded-' + (++serial); replacements.set(old,el.id);
              });
              li.querySelectorAll('[aria-labelledby],[aria-describedby],[aria-controls],[for]').forEach(el => {
                ['aria-labelledby','aria-describedby','aria-controls','for'].forEach(attr => {
                  if (el.hasAttribute(attr)) el.setAttribute(attr,el.getAttribute(attr).split(' ').map(id=>replacements.get(id)||id).join(' '));
                });
              });
              grid.appendChild(li); known.add(template.dataset.zmgProduct);
            });
            view.dataset.total = data.dataset.total || view.dataset.total || '';
            view.dataset.loaded = 'true'; view.dataset.next = data.dataset.next || ''; view.dataset.failed = 'false';
          } catch (error) {
            if (error.name !== 'AbortError') view.dataset.failed = 'true';
          } finally { requests.delete(view); if (root.isConnected) refresh(); }
        })();
        requests.set(view,promise); return promise;
      }
      async function ensure(view) {
        const wanted = limit() * (1 + Number(view.dataset.batches || 0));
        if (view.dataset.loaded !== 'true') await loadPage(view);
        while (view.dataset.failed !== 'true' && view.dataset.next && view.querySelectorAll('[data-zmg-item]').length < wanted && root.isConnected) await loadPage(view);
        if (root.isConnected) refresh();
      }
      function activate(id) { active = id; refresh(); const panel = activePanel(); if(panel) ensure(currentView(panel)); }
      tabs.forEach((tab,index) => {
        listen(tab,'click',()=>activate(tab.dataset.zmgTab));
        listen(tab,'keydown',event=>{
          let target;
          if(event.key==='ArrowRight') target=(index+1)%tabs.length;
          if(event.key==='ArrowLeft') target=(index-1+tabs.length)%tabs.length;
          if(event.key==='Home') target=0;
          if(event.key==='End') target=tabs.length-1;
          if(target===undefined)return;
          event.preventDefault();tabs[target].focus();activate(tabs[target].dataset.zmgTab);
        });
      });
      panels.forEach(panel => {
        panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',panel.id.replace('ZmgPanel-','ZmgTab-'));
        const nav = panel.querySelector('.zmg-models'); if(nav) nav.hidden=false;
        listen(panel,'click',event=>{
          const link = event.target.closest('[data-zmg-model]');
          if(!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button>0)return;
          event.preventDefault();
          selectedModels.set(panel.dataset.zmgPanel,link.dataset.zmgModel);
          let view=currentView(panel);
          if(!view){
            view=document.createElement('div');view.dataset.zmgView=link.dataset.zmgModel;view.dataset.url=link.getAttribute('href');view.dataset.loaded='false';view.dataset.total=link.dataset.total || '';
            const grid=document.createElement('ul');grid.className='zmg-grid';grid.setAttribute('role','list');view.appendChild(grid);panel.querySelector('[data-zmg-views]').appendChild(view);
          }
          refresh();ensure(view);
        });
        listen(panel.querySelector('[data-zmg-more]'),'click',async()=>{
          const view=currentView(panel); const previous=limit()*(1+Number(view.dataset.batches||0));
          view.dataset.batches=Number(view.dataset.batches||0)+1;await ensure(view);
          if(panel===activePanel() && view===currentView(panel)){
            view.querySelectorAll('[data-zmg-item]')[previous]?.querySelector('.card__heading a, a')?.focus({preventScroll:true});
            const status=root.querySelector('.zmg-status');status.textContent=status.dataset.pattern.replace('[count]',view.querySelectorAll('[data-zmg-item]:not([hidden])').length);
          }
        });
        listen(panel.querySelector('[data-zmg-retry]'),'click',()=>{const view=currentView(panel);view.dataset.failed='false';loadPage(view).then(()=>ensure(view));});
      });
      listen(breakpoint,'change',()=>{refresh();const panel=activePanel();if(panel)ensure(currentView(panel));});
      listen(document,'shopify:block:select',event=>{if(tabs.some(t=>t.dataset.zmgTab===event.detail?.blockId))activate(event.detail.blockId);});
      root.classList.add('zmg-enhanced');root.querySelector('.zmg-tabs').hidden=!tabs.length;
      if(active)activate(active);

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function modulo(value, count) {
    return ((value % count) + count) % count;
  }

  function setTransform(track, px, animate) {
    track.style.transition = animate
      ? "transform 520ms cubic-bezier(.22,.61,.36,1)"
      : "none";

    track.style.transform = "translate3d(" + px + "px,0,0)";
  }

  function loadImageInSlide(slide) {
    if (!slide) return;

    var image = slide.querySelector("img[data-src]");

    if (!image) return;

    var src = image.getAttribute("data-src");
    var srcset = image.getAttribute("data-srcset");

    function revealImage() {
      image.classList.add("is-loaded");
    }

    image.addEventListener("load", revealImage, { once: true });

    if (srcset) {
      image.setAttribute("srcset", srcset);
    }

    if (src) {
      image.setAttribute("src", src);
    }

    image.removeAttribute("data-src");
    image.removeAttribute("data-srcset");

    if (image.complete && image.naturalWidth > 0) {
      revealImage();
    }
  }

  function initGallery(gallery) {
    if (gallery.dataset.zetaInitialized === "true") return;

    gallery.dataset.zetaInitialized = "true";

    var shell = gallery.closest("[data-zeta-gallery-shell]");
    var track = gallery.querySelector("[data-zeta-gallery-track]");

    var realSlides = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-zeta-gallery-slide]")
    );

    var count = realSlides.length;

    if (!track || count < 2) return;

    var firstClone = realSlides[0].cloneNode(true);
    var lastClone = realSlides[count - 1].cloneNode(true);

    firstClone.setAttribute("data-zeta-clone", "first");
    lastClone.setAttribute("data-zeta-clone", "last");

    firstClone.setAttribute("aria-hidden", "true");
    lastClone.setAttribute("aria-hidden", "true");

    firstClone.setAttribute("tabindex", "-1");
    lastClone.setAttribute("tabindex", "-1");

    track.insertBefore(lastClone, track.firstChild);
    track.appendChild(firstClone);

    var allSlides = Array.prototype.slice.call(track.children);

    var prev = shell
      ? shell.querySelector("[data-zeta-gallery-prev]")
      : null;

    var next = shell
      ? shell.querySelector("[data-zeta-gallery-next]")
      : null;

    var position = 1;
    var logicalIndex = 0;

    var pointerId = null;
    var startX = 0;
    var deltaX = 0;
    var dragging = false;
    var suppressClick = false;
    var animating = false;
    var wheelLocked = false;

    var peekCancelled = false;
    var peekTimer = null;
    var peekAnimation = null;

    function width() {
      return gallery.clientWidth;
    }

    function transformForPosition(targetPosition) {
      return -targetPosition * width();
    }

    function render(animate) {
      setTransform(
        track,
        transformForPosition(position),
        animate
      );
    }

    function loadLogical(index) {
      index = modulo(index, count);
      loadImageInSlide(allSlides[index + 1]);
    }

    function loadPhysical(targetPosition) {
      loadImageInSlide(allSlides[targetPosition]);
    }

    function preloadNeighbours() {
      loadLogical(logicalIndex);
      loadLogical(logicalIndex + 1);
      loadLogical(logicalIndex - 1);
    }

    function normalizeLoop() {
      if (position === 0) {
        position = count;
        logicalIndex = count - 1;
        render(false);
      }

      if (position === count + 1) {
        position = 1;
        logicalIndex = 0;
        render(false);
      }

      preloadNeighbours();
    }

    function afterTransition() {
      animating = false;
      normalizeLoop();
    }

    track.addEventListener("transitionend", function(event) {
      if (event.propertyName !== "transform") return;
      afterTransition();
    });

    function cancelPeek() {
      peekCancelled = true;

      if (peekTimer) {
        clearTimeout(peekTimer);
        peekTimer = null;
      }

      if (peekAnimation) {
        try {
          peekAnimation.cancel();
        } catch (error) {}

        peekAnimation = null;
      }

      render(false);
    }

    function moveBy(direction) {
      if (animating) return;

      cancelPeek();

      logicalIndex = modulo(logicalIndex + direction, count);
      position += direction;

      loadPhysical(position);
      loadLogical(logicalIndex);

      animating = true;
      render(true);

      setTimeout(function() {
        if (animating) afterTransition();
      }, 620);
    }

    if (prev) {
      prev.addEventListener("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        moveBy(-1);
      });
    }

    if (next) {
      next.addEventListener("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        moveBy(1);
      });
    }

    if (shell) {
      shell.addEventListener("pointerenter", function() {
        preloadNeighbours();
      }, { passive: true });
    }

    gallery.addEventListener("pointerdown", function(event) {
      if (event.pointerType === "mouse" && event.button !== 0) {
        return;
      }

      cancelPeek();
      preloadNeighbours();

      pointerId = event.pointerId;
      startX = event.clientX;
      deltaX = 0;
      dragging = false;

      track.style.transition = "none";
    });

    gallery.addEventListener("pointermove", function(event) {
      if (
        pointerId === null ||
        event.pointerId !== pointerId
      ) {
        return;
      }

      deltaX = event.clientX - startX;

      if (!dragging && Math.abs(deltaX) > 6) {
        dragging = true;
        gallery.classList.add("is-dragging");

        try {
          gallery.setPointerCapture(pointerId);
        } catch (error) {}
      }

      if (!dragging) return;

      setTransform(
        track,
        transformForPosition(position) + deltaX,
        false
      );
    });

    function endPointer(event) {
      if (
        pointerId === null ||
        event.pointerId !== pointerId
      ) {
        return;
      }

      try {
        if (
          gallery.hasPointerCapture &&
          gallery.hasPointerCapture(pointerId)
        ) {
          gallery.releasePointerCapture(pointerId);
        }
      } catch (error) {}

      gallery.classList.remove("is-dragging");

      if (dragging) {
        var threshold = Math.min(width() * .14, 65);

        suppressClick = true;

        if (deltaX < -threshold) {
          logicalIndex = modulo(logicalIndex + 1, count);
          position += 1;

          loadPhysical(position);
          loadLogical(logicalIndex);

          animating = true;
          render(true);
        } else if (deltaX > threshold) {
          logicalIndex = modulo(logicalIndex - 1, count);
          position -= 1;

          loadPhysical(position);
          loadLogical(logicalIndex);

          animating = true;
          render(true);
        } else {
          render(true);
        }

        if (animating) {
          setTimeout(function() {
            if (animating) afterTransition();
          }, 620);
        }

        setTimeout(function() {
          suppressClick = false;
        }, 250);
      } else {
        render(false);
      }

      pointerId = null;
      deltaX = 0;
      dragging = false;
    }

    gallery.addEventListener("pointerup", endPointer);
    gallery.addEventListener("pointercancel", endPointer);

    gallery.addEventListener("click", function(event) {
      if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    gallery.addEventListener("wheel", function(event) {
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) {
        return;
      }

      if (Math.abs(event.deltaX) < 8) return;

      event.preventDefault();

      if (wheelLocked || animating) return;

      wheelLocked = true;

      if (event.deltaX > 0) {
        moveBy(1);
      } else {
        moveBy(-1);
      }

      setTimeout(function() {
        wheelLocked = false;
      }, 480);
    }, { passive: false });

    function initPeek() {
      if (gallery.dataset.peek !== "true") return;

      if (
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ) {
        return;
      }

      loadLogical(1);

      var repeats = parseInt(
        gallery.dataset.peekRepeats || "3",
        10
      );

      repeats = clamp(repeats, 1, 3);

      var pause = parseFloat(
        gallery.dataset.peekDelay || "2"
      ) * 1000;

      var distancePercent = parseFloat(
        gallery.dataset.peekDistance || "28"
      );

      var repetition = 0;

      function play() {
        if (peekCancelled || logicalIndex !== 0) return;

        var base = transformForPosition(position);

        var distance = Math.min(
          width() * (distancePercent / 100),
          150
        );

        peekAnimation = track.animate(
          [
            {
              transform: "translate3d(" + base + "px,0,0)",
              offset: 0
            },
            {
              transform: "translate3d(" + (base - distance) + "px,0,0)",
              offset: .40
            },
            {
              transform: "translate3d(" + (base - distance) + "px,0,0)",
              offset: .53
            },
            {
              transform: "translate3d(" + base + "px,0,0)",
              offset: 1
            }
          ],
          {
            duration: 2100,
            easing: "cubic-bezier(.22,.61,.36,1)",
            iterations: 1
          }
        );

        peekAnimation.onfinish = function() {
          peekAnimation = null;
          render(false);

          if (peekCancelled) return;

          repetition += 1;

          if (repetition >= repeats) return;

          peekTimer = setTimeout(play, pause);
        };
      }

      function start() {
        peekTimer = setTimeout(play, 900);
      }

      if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (
              entry.isIntersecting &&
              entry.intersectionRatio >= .55
            ) {
              observer.disconnect();
              start();
            }
          });
        }, { threshold: [.55] });

        observer.observe(gallery);
        cleanups.push(() => observer.disconnect());
      } else {
        start();
      }
    }

    if ("ResizeObserver" in window) {
      var resizeObserver = new ResizeObserver(function() {
        render(false);
      });

      resizeObserver.observe(gallery);
    cleanups.push(() => resizeObserver.disconnect());
    }

    render(false);
    loadLogical(0);

    /* Précharge les visuels voisins à proximité du viewport. */
    if ("IntersectionObserver" in window) {
      var imagePreloadObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            preloadNeighbours();
            imagePreloadObserver.disconnect();
          }
        });
      }, { rootMargin: "300px 0px" });

      imagePreloadObserver.observe(gallery);
    cleanups.push(() => imagePreloadObserver.disconnect());
    } else {
      preloadNeighbours();
    }

    initPeek();
    cleanups.push(cancelPeek);
  }


    }
    disconnectedCallback() {
      this._cleanups?.forEach(cleanup => cleanup());
      this.querySelectorAll('[data-zeta-gallery]').forEach(gallery => {
        // Replace initialized nodes to discard their own gesture handlers on reattachment.
        const fresh = gallery.closest('[data-zeta-gallery-shell]').cloneNode(true);
        fresh.querySelectorAll('[data-zeta-clone]').forEach(clone => clone.remove());
        fresh.querySelector('[data-zeta-gallery]').removeAttribute('data-zeta-initialized');
        gallery.closest('[data-zeta-gallery-shell]').replaceWith(fresh);
      });
      this._mounted = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
